export default [
  {
    path: "/newsList", // 新闻列表
    name: "newsList",
    component: () =>
      import(/* webpackChunkName: "news" */ "../views/News/NewsList/index.vue"),
    meta: {
      eventId: "W-X-17-V1",
      eventName: "新闻列表曝光",
      module: "新闻动态",
    },
  },
  {
    path: "/newsDetail", // 新闻列表
    name: "newsDetail",
    component: () =>
      import(
        /* webpackChunkName: "news" */ "../views/News/NewsDetail/index.vue"
      ),
    meta: {
      eventId: "W-X-18-V1",
      eventName: "新闻详情曝光",
      module: "新闻动态",
    },
  },
];
